// Children Imports

import CoreProcedures from "./CoreProcedures/routes.js";
import NonCons from "./NonCons/routes.js";
import Procedures from "./Procedures/routes.js";
import ReportPlanner from "./ReportPlanner/routes.js";
import Reports from "./Reports/routes.js";
import Settings from "./Settings/routes.js";
import SubNonCons from "./SubNonCons/routes";
import SubReports from "./SubReports/routes";

// Quality System imports (from Home)




// Audits app switcher route
const auditsAppRoute = {
    path: "/Audits",
    redirect: "/Audits/ReportPlanner",
    name: "Audits",
    meta: {
        app: "Audits",
        sideNav: false,
        appSwitcher: true,
        appSwitcherPosition: 4,
        icon: "check-circle",
        name: "Audits",
        hidden(user) {
           return !user?.Security?.Audits?.Read;
        }
    }
};

export default [auditsAppRoute, ...ReportPlanner, ...Reports, ...NonCons, ...Procedures, ...CoreProcedures, ...SubReports, ...SubNonCons, ...Settings];
